import React from 'react'
import { Typography, Button, Row, Col} from 'antd'
import { MODAL_SIZE_LARGE } from 'constants/Layout'
import Vocabulary from 'components/Vocabulary';

const { Text } = Typography

export const ConfigurationInstructions = ({ toolName, onCancel, onStart }) => {
  return (
      <div className="d-flex flex-column">
          <Text className="text-bold scan-heading-dark">Configure multiple {toolName} projects</Text>
          <ul>
              <li><div className="m-t-l m-b-l"><Text className="scan-heading">Enter endpoint, username, password details and fetch the {toolName} projects.</Text></div></li>
              <li><div className="m-t-l m-b-l"><Text className="scan-heading">After fetching the {toolName} projects, you can map the {toolName} projects, <Vocabulary name="product" isLowerCase={true}/> and <Vocabulary name="subProduct" isLowerCase={true}/> based on ArmorCode platform.</Text></div></li>
          </ul>
          <div className="d-flex justify-content-between">
              <Button onClick={onCancel} type="default">Cancel</Button>
              <Button onClick={onStart} type="primary">Start</Button>
          </div>
      </div>
  )
}

export const PanelHeader = ({ loginConfig, extraFields, index }) => {
  const {name, identifier, username, apiEndpoint, total_configurations} = loginConfig;

  return (
    <Row className="align-items-center">
      <Col span={20}>
        {name && <Typography.Text className="m-r-l">Name: {name}</Typography.Text>}
        {username && <Typography.Text className="m-r-l">Username: {username}</Typography.Text>}
        {identifier && <Typography.Text className="m-r-l">Identifier: {identifier}</Typography.Text>}
        {apiEndpoint && <Typography.Text className="m-r-l">Endpoint: {apiEndpoint}</Typography.Text>}
        {extraFields && extraFields[index]}
        {<Typography.Text className="m-r-l">{total_configurations === 0 ? "No Mappings Available" :`Mappings: ${total_configurations}`}</Typography.Text>}
      </Col>
    </Row>
  )
}

export const modalProps = {
  footer: null,
  width: MODAL_SIZE_LARGE,
  // bodyStyle: {height: 500, paddingLeft: 90, paddingRight: 90, paddingTop: 90},
  style: { top: 80 },
}
